import { mergeScript } from '../state';
import type { Lead } from '../types';

export function ScriptTab({ html, lead, agentName }: { html: string; lead: Lead | null; agentName: string }) {
  // Script HTML is campaign admin content, allowlist-sanitized by the BFF (AE-10888) and rendered under its CSP;
  // merge values are HTML-escaped in mergeScript.
  return <div id="ScriptContents" dangerouslySetInnerHTML={{ __html: mergeScript(html, lead, agentName) }} />;
}
